"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaKekkaJissiDate = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 内部監査実施日時
 */
const KansaKekkaJissiDate = props => {
  const {
    intl,
    naibukansaJissiDt,
    onChange,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_KANSA_JISSI_DATE
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: naibukansaJissiDt,
    onChange: onChange,
    name: 'naibukansaJissiDt',
    error: !!error,
    helperText: helperText
  })));
};
exports.KansaKekkaJissiDate = KansaKekkaJissiDate;
var _default = exports.default = (0, _reactIntl.injectIntl)(KansaKekkaJissiDate);